module.exports = __webpack_public_path__ + "static/media/planilha.4d9e35ec.xlsx";